import React from 'react';
import './DispositionFilterBar.css';

export default function DispositionFilterBar({
  sites, sitesLoading,
  siteId, onSiteChange,
  oem, onOemChange,
  oemOptions, oemLoading,
  gapsOnly, onGapsOnlyChange,
}) {
  return (
    <div className="dispositions-filter-bar">
      <select
        className="dispositions-filter-select"
        value={siteId || ''}
        onChange={e => onSiteChange(e.target.value)}
        disabled={sitesLoading}
        aria-label="Site"
      >
        <option value="">{sitesLoading ? 'Loading sites...' : '— Select a site —'}</option>
        {(sites || []).map(s => (
          <option key={s.site_id} value={s.site_id}>
            {s.site_city ? `${s.site_name} (${s.site_city})` : s.site_name}
          </option>
        ))}
      </select>

      <select
        className="dispositions-filter-select"
        value={oem || ''}
        onChange={e => onOemChange(e.target.value)}
        disabled={oemLoading}
        aria-label="OEM"
      >
        <option value="">(All OEMs)</option>
        {(oemOptions || []).map(o => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>

      <label className="dispositions-filter-toggle">
        <input
          type="checkbox"
          checked={!!gapsOnly}
          onChange={e => onGapsOnlyChange(e.target.checked)}
        />
        <span>Show data gaps only</span>
      </label>
    </div>
  );
}
